import { useContext } from 'react';

import { MonitorContext } from '../providers/monitor';

export const useMonitor = () => useContext(MonitorContext);
